var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Mcp_Wheel-loader",class:{
      display: _vm.display,
      fixed: _vm.fixed
    }},[_c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"icon--inline",attrs:{"symbol":"Loader","size":("0 0 " + _vm.wheelSize + " " + _vm.wheelSize),"role":"presentation"}})])}
var staticRenderFns = []

export { render, staticRenderFns }